export const HTTP_STATUS_CODES = {
  /*
   * HTTP 409 indicate that the request can not be satisfied because the current
   * state is incompatible with what is required
   * */
  CONFLICT: 409,
  BAD_REQUEST: 400,
  INTERNAL_ERROR: 500,
};
